import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './fonts.css';
import './App.css';
import Home from './components/Home';
import Imprint from './components/Imprint';
import Access from './components/Access';
import AuthForm from './components/AuthForm';
import ApplicationDashboard from './components/ApplicationDashboard';
import PasswordProtection from './components/PasswordProtection';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/access" element={<Access />} />
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/teamdashboard" element={
            <PasswordProtection>
              <ApplicationDashboard />
            </PasswordProtection>
          } />
        </Routes>
    </div>
    </Router>
  );
}

export default App;
